/**
 * Color schemes for demographic charts
 */

export const DEFAULT_CHART_COLORS = [
  '#3b82f6', // blue-500
  '#22c55e', // green-500
  '#f59e0b', // amber-500
  '#ef4444', // red-500
  '#8b5cf6', // violet-500
  '#ec4899', // pink-500
  '#14b8a6', // teal-500
  '#f97316', // orange-500
]

/**
 * Color schemes for different demographic categories
 */
export const DEMOGRAPHIC_COLORS = {
  age: ['#3b82f6', '#22c55e', '#f59e0b', '#ef4444'], // Blue, Green, Amber, Red
  education: ['#ef4444', '#f59e0b', '#22c55e'], // Red, Amber, Green (low to high)
  income: ['#ef4444', '#f59e0b', '#22c55e'], // Red, Amber, Green (low to high)
  settlement: ['#22c55e', '#3b82f6', '#8b5cf6'], // Green, Blue, Violet (rural to urban)
  religion: DEFAULT_CHART_COLORS,
}
